export const baseurl = "https://node.empowerplus.co.in"; //live  
// export const baseurl ="http://192.168.200.27:5200";
const commonUrl = `${baseurl}/api/v1`;
const user = `${commonUrl}/user`;
const category = `${commonUrl}/category`;
const admin = `${commonUrl}/admin`;
const emergency = `${commonUrl}/emergency`;
const resource = `${commonUrl}/resource`;
const staticbanner = `${commonUrl}/static`;
const periodTracker = `${commonUrl}/periodTracker`;
const static1 = `${commonUrl}/static`; 
const faq = `${commonUrl}/static`;
const activities = `${commonUrl}/activities`;
const menstrualHygiene = `${commonUrl}/menstrualHygiene`;

const apiConfig = {
  stateList: `${commonUrl}/state`,
  districtList: `${commonUrl}/district`,
  admin: admin,
  
  // user api
  login: `${admin}/login`,
  forgotPassword: `${admin}/forgotPassword`,
  verifyOTP: `${admin}/verifyOTP`,
  resetPassword: `${admin}/resetPassword`,
  listUsers: `${admin}/listUsers`,
  xlsxDownload: `${admin}/xlsxDownload`,
  xlsxUpload: `${admin}/xlsxUpload`,
  viewUsers: `${admin}/viewUsers`,
  blockUnblockUsers: `${admin}/blockUnblockUsers`,
  updateProfile: `${admin}/updateProfile`,
  getProfile: `${admin}/getProfile`,
  feedbackList: `${admin}/feedbackList`,
  feedbackView: `${admin}/feedbackView`,
  adminDashboard: `${admin}/adminDashboard`,
  registeredUserGraph: `${admin}/registeredUserGraph`,
  dashboardPieChart: `${admin}/preferredLanguagePie`,
  listReport: `${admin}/listReport`,
  historyPeriod: `${admin}/historyPeriod`,
  listMoodTracker: `${admin}/listMoodTracker`,
  savedChatBotAnswers: `${admin}/savedChatBotAnswers`,
  //category api
  listCategory: `${category}/listCategory`,
  viewCategory: `${category}/viewCategory`,
  editCategory: `${category}/editCategory`,
  addCategory: `${category}/addCategory`,
  deleteCategory: `${category}/deleteCategory`,

  // emergency
  listEmergency: `${emergency}/listEmergency`,
  viewEmergency: `${emergency}/viewEmergency`,
  editEmergency: `${emergency}/editEmergency`,
  addEmergency: `${emergency}/addEmergency`,
  deleteEmergency: `${emergency}/deleteEmergency`,

  //ACTIVITY MANAGEMENT
  listActivity: `${user}/listActivity`,
  listSubActivity: `${user}/listSubActivity`,
  uploadFile: `${user}/uploadFile`,
  // uploadFile: `https://node.empowerplus.dhwaniris.in/api/v1/user/uploadFile`,
  climateChangeInfoNDisaster: `${commonUrl}/climateChangeAndDisaster`,
  climateChangeContent: `${commonUrl}/climateChangeContent`,
  carbonFootprintQuestions: `${commonUrl}/environmentalInsights`,
  
  //Resource management
  addResource: `${resource}/addResource`,
  listResource: `${resource}/listResource`,
  viewResource: `${resource}/viewResource`,
  deleteResource: `${resource}/deleteResource`,
  editResource: `${resource}/editResource`,
  deleteResource: `${resource}/deleteResource`,

  //BANNER MANAGEMENT
  addBanner: `${staticbanner}/addBanner`,
  listBanner: `${staticbanner}/listBanner`,
  listAdminBanner: `${staticbanner}/listAdminBanner`,
  blockunblockBanner: `${staticbanner}/blockunblockBanner`,

  viewBanner: `${staticbanner}/viewBanner`,

  deleteBanner: `${staticbanner}/deleteBanner`,
  editBanner: `${staticbanner}/editBanner`,

  //periodTracker management section
  listPeriodTracker: `${periodTracker}/listPeriodTracker`,
  addPeriodTracker: `${periodTracker}/addPeriodTracker`,
  editPeriodTracker: `${periodTracker}/editPeriodTracker`,
  viewPeriodTracker: `${periodTracker}/viewPeriodTracker`,
  blockUnblockPeriodTracker: `${periodTracker}/blockUnblockPeriodTracker`,
  deletePeriodTracker: `${periodTracker}/deletePeriodTracker`,

  staticContentList: `${static1}/staticContentList`,
  viewStaticContent: `${static1}/staticContent`,
  editStaticContent: `${static1}/staticContent`,

  //faq section
  listFAQ: `${faq}/listFAQ`,
  addFaq: `${faq}/addFaq`,
  editFaq: `${faq}/editFaq`,
  deleteFaq: `${static1}/deleteFaq`,
  viewFAQ: `${static1}/viewFAQ`,

  //LIST SUBACTIVITIES
  personalSafetySubList: `${activities}/personalSafetySubList`,
  viewPersonalSafetySubData: `${activities}/viewPersonalSafetySubData`,
  updatePersonalSafetySubData: `${activities}/updatePersonalSafetySubData`,
  addPersonalSafetySubData: `${activities}/addPersonalSafetySubData`,
  listSleepTrainingData: `${activities}/listSleepTrainingData`,
  viewSleepTrainingData: `${activities}/viewSleepTrainingData`,
  editSleepTrainingData: `${activities}/editSleepTrainingData`,
  blockPersonalSafetySubData: `${activities}/blockPersonalSafetySubData`,
  blockSleepTrainingData: `${activities}/blockSleepTrainingData`,
  listSleepTrackingData: `${activities}/listSleepTrackingData`,
  addSleepTrackingData: `${activities}/addSleepTrackingData`,
  editSleepTrackingData: `${activities}/editSleepTrackingData`,
  viewSleepTrackingData: `${activities}/viewSleepTrackingData`,
  blockSleepTrackingData: `${activities}/blockSleepTrackingData`,
  addSleepTrainingData: `${activities}/addSleepTrainingData`,
  listMentalAndWellBeingData: `${activities}/listMentalAndWellBeingData`,
  viewMentalAndWellBeingData: `${activities}/viewMentalAndWellBeingData`,
  addMentalAndWellBeingData: `${activities}/addMentalAndWellBeingData`,
  editMentalAndWellBeingData: `${activities}/editMentalAndWellBeingData`,
  blockMentalAndWellBeingData: `${activities}/blockMentalAndWellBeingData`,
  deleteSleepTrainingData: `${activities}/deleteSleepTrainingData`,
  deleteSleepTrackingData: `${activities}/deleteSleepTrackingData`,
  deleteMentalAndWellBeingData: `${activities}/deleteMentalAndWellBeingData`,

  // menstrualHygiene
  listMenstrualHygiene: `${menstrualHygiene}/listMenstrualHygiene`,
  listMenstrualHygieneCategory: `${menstrualHygiene}/listMenstrualHygieneCategory`,
  addMenstrualHygieneCategory: `${menstrualHygiene}/addMenstrualHygieneCategory`,
  editMenstrualHygieneCategory: `${menstrualHygiene}/editMenstrualHygieneCategory`,
  deleteMenstrualHygieneCategory: `${menstrualHygiene}/deleteMenstrualHygieneCategory`,
  

  addMenstrualHygiene: `${menstrualHygiene}/addMenstrualHygiene`,
  editMenstrualHygiene: `${menstrualHygiene}/editMenstrualHygiene`,
  viewMenstrualHygiene: `${menstrualHygiene}/viewMenstrualHygiene`,
  viewMenstrualHygieneCategory: `${menstrualHygiene}/viewMenstrualHygieneCategory`,
  blockUnblockMenstrualHygiene: `${menstrualHygiene}/blockUnblockMenstrualHygiene`,
  deleteMenstrualHygiene: `${menstrualHygiene}/deleteMenstrualHygiene`,
  createChatbotTrainQuestion: `${admin}/createChatbotTrainQuestion`,
  editChatbotTrainQuestion: `${admin}/editChatbotTrainQuestion`,
  listChatbotTrainQuestion: `${admin}/listChatbotTrainQuestion`,
  trainChatModel: `${admin}/trainChatModel`,
  viewChatbotTrainQuestion: `${admin}/viewChatbotTrainQuestion`,

  // Firebase Analytics
  firebaseAnalytics: `${commonUrl}/google-analytics/analytics-data`,

  // Chatboat
  chatDashboard: `${admin}/chatDashboardData`,

  // csv
  contentReportCSV: `${admin}/contentReportCsv`,
  chatbotReportCSV: `${admin}/chatbotReportCsv`,
  userFeedbackCSV: `${admin}/userFeedbackSummaryCsv`,
  firebaseAnalyticsCSV: `${admin}/firebaseAnalyticsCsv`,
  mentalMentrualHealthCSV: `${admin}/adminDashboard`,
  
};

export default apiConfig;
